import React, { useEffect, useState } from "react";

/* -------- packages -------- */
import {  Modal, ModalHeader, ModalBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
/* -------- ------- -------- */

/* -------- components -------- */
import TableContainer from "../List/TableContainer";
/* -------- ------- -------- */

/* -------- intern functions -------- */
/* -------- ------- -------- */

export default function DocumentsModal ({documents, isModalOpen, setModalOpen, filterConfig}) { // isModalOpen (BOOLEAN), setModalOpen (useState Function(true/false))
    const { t } = useTranslation();


    const documentsModalValues = documents;
    const [uploadedDocument, setUploadedDocument] = useState('');
    const [isPrivateNewDocument, setIsPrivateNewDocument] = useState(false)


  /* ----------------- Documents MODAL Components ----------------- */

  const handleUploadDocument = (linkedEntityId) => {
    const error = t('noFileSelectioned')
    if (!uploadedDocument) {
      return toast.warning(error, {
        position: "top-center",
        autoClose: 5000,
        draggable: true,
        });
    }

    const newDocumentData = new FormData();


    newDocumentData.append('file', uploadedDocument);

    const newDocument = {
      docFilename: uploadedDocument.name,
      docSize: uploadedDocument.size,
      isPrivate: isPrivateNewDocument,
      linkedEntityId: linkedEntityId,
    }


  }

  const DocumentElement = ({documents}) => {
    const documentsWithType = []

    documents.map(obj => {
      const docType = obj.docFilename.split('.').pop();
  
      documentsWithType.push({
        ...obj,
        docType: docType
      })
    });


    const columnConfig = [
      { key: 'id', type: 'text' },
      { key: 'docKey', type: 'text'},
      { key: 'docType', type: 'text'},
      { key: 'addedAt', type: 'date' },
    ];
    
    return (
          <TableContainer
            isModal={true}
            columnConfig={columnConfig}
            filterConfig={filterConfig}
            data={documentsWithType}
            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            theadClass="table-light"
            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            pagination="pagination"
            divClassName="table-responsive"
            isBordered={true}
            isPagination={true}
            prefListName="group"
            withoutActions={true}
            actions="documents"
          />
        
    )

  }
  /* ---------------------------------------------------------- */



    return (
      <Modal isOpen={isModalOpen} toggle={() => setModalOpen.setIsDocumentsModalOpen(false)} centered={true} size={'xl'} scrollable={true}>
        <ModalHeader toggle={() => setModalOpen.setIsDocumentsModalOpen(false)}>{t('ProjDocuments')}</ModalHeader>
        <div className="groupsModal">
        <ModalBody>
          <div className="container documentsModal">
                      <div className="card">
                          <div className="card-header">
                                <div className="uploadDocumentContainer">
                                    <label htmlFor="file-upload" className="btn btn-primary">
                                        <i className='mdi mdi-paperclip'></i> {t('selectFile')}
                                    </label>
                                    <input id="file-upload" type="file" className="uploadFileInput" onChange={(e) => setUploadedDocument(e.target.files[0])} />
                                        <p className="fileName">{uploadedDocument && uploadedDocument.name}</p>
                                 </div>

                            <div className="uploadBtnsContainer">
                                <span className="btnsContainer">
                                    <i className={'bx bx-lock iconTable lock' + (isPrivateNewDocument ? ' customDynamicColor' : '')} onClick={() => setIsPrivateNewDocument(true)} ></i>
                                    <i className={'mdi mdi-lock-open-variant-outline iconTable' + (!isPrivateNewDocument ? ' customDynamicColor' : '')} onClick={() => setIsPrivateNewDocument(false)}  ></i>
                                </span>
                                <button className="btn btn-primary" 
                                        onClick={ () => handleUploadDocument(documentsModalValues, 
                                                                                (documentsModalValues && 
                                                                                documentsModalValues[0] && 
                                                                                documentsModalValues[0].linkedEntityId) || 
                                                                            undefined)}> 
                                    <i className='bx bx-upload'></i> {t('uploadFile')}
                                </button>
                            </div>
                          </div>

                          <div className="card-body">
                              <div id="content">

                                  {documentsModalValues &&  (
                                    <DocumentElement documents={documentsModalValues}/>
                                  )
                                  }

                                  {
                                    (documentsModalValues == null) <= 0 && <div className="card"></div>
                                  }

                              </div>
                          </div>
                      </div>

          </div>
        </ModalBody>
        </div>
      </Modal>
    )

}